import React, { useEffect, useState } from 'react';
import {
  Layout,
  Breadcrumb,
  Form,
  Input,
  Select,
  Button,
  Typography,
  Row,
  Col,
  Divider,
  Spin,
} from 'antd';
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";
import { MAINAPIURL, APPBACKGROUND_COLOR } from '../appsettings';
import axios from 'axios';
import { useForm } from 'antd/es/form/Form';
import { AlertError, AlertSuccess } from '../usableclasses.js';

const { Content } = Layout;
const { Title } = Typography;

const Financial = () => {
  const ApiURL = MAINAPIURL;
  const TOKEN = localStorage.getItem("AUTHCODE");
  const [loading, setLoading] = useState(false);
  const [financialYear, setFinancialYear] = useState('xxxx');
  const UPDATED_BY = localStorage.getItem("USERID");
  const [form] = useForm();

  useEffect(() => {
    fetchFinancialSettings();
  }, []);

  const fetchFinancialSettings = async () => {
    try {
      setLoading(true);
      const headers = { SystemAccessToken: TOKEN };
      const response = await axios.get(`${ApiURL}/settings/financialsettings`, { headers });
      const financialSettings = response.data;
      setFinancialYear(financialSettings.financialYear);
      form.setFieldsValue({
        systemYear: financialSettings.systemYear,
        systemMonth: financialSettings.systemMonth,
        cpCalValue: financialSettings.cpCalValue,
        bvCalValue: financialSettings.bvCalValue,
        bpCalValue: financialSettings.bpCalValue
      });
    } catch (error) {
      console.error('Error fetching financial settings:', error);
      AlertError('Failed to fetch financial settings.');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (values) => {
    const payload = {
      year: values.systemYear,
      month: values.systemMonth,
      cpValue: parseFloat(values.cpCalValue),
      bvValue: parseFloat(values.bvCalValue),
      bpValue: parseFloat(values.bpCalValue),
      updatedBy: UPDATED_BY
    };

    try {
      setLoading(true);
      const headers = { SystemAccessToken: TOKEN };
      await axios.post(`${ApiURL}/settings/financialsettingsupdate`, payload, { headers });
      AlertSuccess('Financial settings updated successfully!');
      fetchFinancialSettings();
    } catch (error) {
      console.error('Error updating financial settings:', error);
      AlertError('Failed to update financial settings.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Spin spinning={loading} tip="Processing...">
      <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
        <Headerdiv />
        <Content style={{ padding: '10px' }}>
          <Breadcrumb style={{ margin: '16px 0' }}>
            <Breadcrumb.Item>Settings</Breadcrumb.Item>
            <Breadcrumb.Item>Financial Settings</Breadcrumb.Item>
          </Breadcrumb>

          <div style={{ padding: 10, minHeight: '65vh', background: '#fff', borderRadius: 8 }}>
            <Title level={5}>Financial Year : {financialYear}</Title>

            <Form layout="vertical" form={form} onFinish={handleSave}>
              <Divider />
              <Row gutter={16} align="bottom">
                <Col xs={24} md={4}>
                  <Form.Item
                    name="systemYear"
                    label={<span style={{ fontWeight: 'bold' }}>Operational Year</span>}
                  >
                    <Input placeholder="Year" maxLength={4} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={4}>
                  <Form.Item
                    name="systemMonth"
                    label={<span style={{ fontWeight: 'bold' }}>Operational Month</span>}
                  >
                    <Select placeholder="Month">
                      {[
                        "January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                      ].map((month, index) => {
                        const value = String(index + 1).padStart(2, '0');
                        return (
                          <Select.Option key={value} value={value}>
                            {month}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={4}>
                  <Form.Item
                    name="cpCalValue"
                    label={<span style={{ fontWeight: 'bold' }}>CP Value</span>}
                  >
                    <Input placeholder="Value" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={4}>
                  <Form.Item
                    name="bvCalValue"
                    label={<span style={{ fontWeight: 'bold' }}>BV Value</span>}
                  >
                    <Input placeholder="Value" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={4}>
                  <Form.Item
                    name="bpCalValue"
                    label={<span style={{ fontWeight: 'bold' }}>BP Value</span>}
                  >
                    <Input placeholder="Value" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={4}>
                  <Form.Item>
                    <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
                      Save
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </Content>
        <Footerdiv />
      </Layout>
    </Spin>
  );
};

export default Financial;